module.exports = __webpack_public_path__ + "static/media/HCMM954.0fa7976a.jpg";